import React, { useState } from 'react';
import './App.css';
import { ExamplePresentation } from './commercial-proposal';
import { DeprisaSm08506, DeprisaSm08508 } from './proposals';

type View = 'home' | 'example' | 'deprisa-sm085-06' | 'deprisa-sm085-08';

const validViews: View[] = ['home', 'example', 'deprisa-sm085-06', 'deprisa-sm085-08'];

const getViewFromHash = (): View => {
  if (typeof window === 'undefined') {
    return 'deprisa-sm085-08';
  }
  const hash = window.location.hash.replace('#', '');
  return validViews.includes(hash as View) ? (hash as View) : 'deprisa-sm085-08';
};

function App() {
  const [currentView, setCurrentView] = useState<View>(getViewFromHash);

  React.useEffect(() => {
    const handlePopState = () => {
      setCurrentView(getViewFromHash());
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  React.useEffect(() => {
    const targetHash = `#${currentView}`;
    if (window.location.hash !== targetHash || window.history.state?.view !== currentView) {
      window.history.replaceState({ view: currentView }, '', targetHash);
    }
  }, [currentView]);

  // Push state when changing views
  const navigateTo = (view: View) => {
    setCurrentView(view);
    window.history.pushState({ view }, '', `#${view}`);
  };

  if (currentView === 'example') {
    return <ExamplePresentation />;
  }

  if (currentView === 'deprisa-sm085-06') {
    return <DeprisaSm08506 />;
  }

  if (currentView === 'deprisa-sm085-08') {
    return <DeprisaSm08508 />;
  }

  // Home view
  return (
    <div className="App">
      <div className="home-container">
        <header className="home-header">
          <h1>Slides Templates</h1>
          <p>Select a presentation template or view an example</p>
        </header>

        <section className="templates-section">
          <h2>Template</h2>
          <div className="cards-grid">
            <div className="presentation-card template-card" onClick={() => navigateTo('example')}>
              <div className="card-icon">📋</div>
              <h3>Commercial Proposal</h3>
              <p>Example presentation showcasing all available components</p>
              <span className="card-badge">Template Example</span>
            </div>
          </div>
        </section>

        <section className="proposals-section">
          <h2>Commercial Proposals</h2>
          
      

        
          <div className="cards-grid">
          {/*
            <div className="presentation-card" onClick={() => navigateTo('deprisa-sm085-06')}>
              <div className="card-icon">👥</div>
              <h3>Deprisa - IT Team Proposal</h3>
              <p>Propuesta de equipo de trabajo TI para Deprisa (SM085-06)</p>
              <span className="card-badge">4 slides</span>
            </div>
    */}
            <div className="presentation-card" onClick={() => navigateTo('deprisa-sm085-08')}>
              <div className="card-icon">🏗️</div>
              <h3>Deprisa - Rearquitectura + APIM</h3>
              <p>Propuesta de modernización arquitectura con API Management (SM085-08)</p>
              <span className="card-badge">5 slides</span>
            </div>

          </div>
        </section>

        <footer className="home-footer">
          <p>Built with React + TypeScript | Manrope + Inter Fonts</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
